module.exports = __webpack_public_path__ + "img/private.94288de.png";